<template>
  <transition name="fadeAppLoading">
    <div class="AppLoading" v-if="loading">
      <div class="logo">
        <img class="sidebar-brand-img" src="img/invest_park_logo.png" />
        <div class="logo-text">
          <div>WAŁBRZYSKA SPECJALNA STREFA EKONOMICZNA</div>
          <div class="en">WAŁBRZYCH SPECIAL ECONOMIC ZONE</div>
        </div>
      </div>
      <div class="loading-text">
        <i class="fas fa-spinner fa-spin fa-2x"></i>
        <span>Trwa ładowanie systemu informacji przestrzennej ...</span>
      </div>
    </div>
  </transition>
</template>

<script>
import Loading from "./Loading";

export default {
  components: { Loading },
  data() {
    return {
      gminyLoaded: false
    };
  },
  computed: {
    loading() {
      return (
        (!this.$parent.$refs.map.currentCenter) || // wymagane dla centerOn - centrowanie na jst, i wyświetlanie tylko danego powiatu
        this.$store.state.jst.status === "loading" ||
        this.$store.state.tereny.status === "loading" ||
        this.$store.state.hale.status === "loading" ||
        this.$store.state.biura.status === "loading" ||
        this.$store.state.tereny.status === "loading" ||
        !this.gminyLoaded
      );
    }
  },
  mounted() {
    this.$root.$on("gminyReady", () => {
      this.gminyLoaded = true;
    });
  }
};
</script>

<style lang="scss" scoped>
// https://vuejs.org/v2/guide/transitions.html
.fadeAppLoading-enter-active,
.fadeAppLoading-leave-active {
  transition: opacity 0.5s;
}
.fadeAppLoading-enter, .fadeAppLoading-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.AppLoading {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: white;
  z-index: 1000;

  color: #294c70;
  text-align: center;

  display: flex;
  flex-direction: column;
  justify-content: center;

  font-weight: bold;

  .logo {
    display: flex;
    align-items: center;
    justify-content: center;

    & > * {
      margin: 0.5rem;
    }

    margin-bottom: 2rem;

    .logo-text {
      text-align: left;

      .en {
        color: #58585a;
      }
    }
  }

  .loading-text {
    display: flex;
    align-items: center;
    justify-content: center;

    & > * {
      margin: 0.5rem;
    }
  }
}
</style>
